"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.aPxToRem = exports.aHover = exports.aFocus = exports.aHidden = void 0;

// Appearance mixins
// --------------------
const aHidden = () => {
  return `
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
  `;
};

exports.aHidden = aHidden;

const aFocus = content => {
  return `
    &:focus {
      outline: 0;
    }

    &:focus-visible {
      ${content}
    }
  `;
};

exports.aFocus = aFocus;

const aHover = content => {
  return `
    @media (hover: hover) {
      &:hover {
        ${content}
      }
    }
  `;
};

exports.aHover = aHover;

const aPxToRem = (px, rootSize = 16) => {
  const pxNum = parseInt(px, 10);
  const rootPxNum = parseInt(rootSize, 10);
  return `
    ${pxNum / rootPxNum}rem
  `;
};

exports.aPxToRem = aPxToRem;